// Plain-HTTP fix for pixel-request-chunks, which hashes every request body with
// crypto.subtle.digest("SHA-256") - even when the request is not chunked. Browsers only
// expose crypto.subtle on HTTPS and localhost, so opened over a LAN address
// (http://192.168.x.x:3000, e.g. from a phone) every request throws before it is sent.
// Where crypto.subtle is missing, SHA-256 is supplied from crypto-js ; on HTTPS and
// localhost the browser's own implementation is kept untouched.
import SHA256 from "crypto-js/sha256";
import WordArray from "crypto-js/lib-typedarrays";

const toArrayBuffer = (wordArray) => {
  const bytes = new Uint8Array(wordArray.sigBytes);
  for (let i = 0; i < wordArray.sigBytes; i++) {
    bytes[i] = (wordArray.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
  }
  return bytes.buffer;
};

const toBytes = (data) => (
  data instanceof ArrayBuffer ? new Uint8Array(data) : new Uint8Array(data.buffer, data.byteOffset, data.byteLength)
);

if (typeof window !== "undefined" && window.crypto && !window.crypto.subtle) {
  Object.defineProperty(window.crypto, "subtle", {
    configurable: true,
    value: {
      digest: async (algorithm, data) => {
        const name = typeof algorithm === "string" ? algorithm : algorithm?.name;
        if (String(name).toUpperCase() !== "SHA-256") {
          throw new Error(`crypto.subtle.digest(${name}) is not available over plain HTTP`);
        }
        return toArrayBuffer(SHA256(WordArray.create(toBytes(data))));
      }
    }
  });
}
